module.exports = __webpack_public_path__ + "img/undraw_profile_image_re_ic2f.e5c16d39.svg";